module.exports = __webpack_public_path__ + "img/title1.ea47a0e6.png";